<template>
  <section
    v-if="modifyBookingPropData"
    class="lookup-reservation component"
  >
    <!-- Mobile Layout Image -->
    <div
      v-if="check.isLgAndDown"
      class="lookup-reservation-image"
    >
      <picture
        v-lazyload="{
          src: `${BookingFormImage}`,
          set: [
            { width: '1024',height: 576, breakpoint: 'xs' },
            { width: '1280', height: 720, breakpoint: 'md' },
            { width: '1600', height: 900, breakpoint: 'lg' },
          ],
          fit: 'crop',
          align: 'center',
        }"
        class="image-wrapper background"
      >
        <img
          class="image"
          src="data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw=="
          :alt="modifyBookingPropData.BookingFormImageAlt"
        >
      </picture>
      <h1 class="lookup-reservation-image__heading">
        {{ BookingFormTitle }}
      </h1>
    </div>

    <!-- Form Content -->
    <div v-if="showLoading" />
    <div
      v-else
      class="lookup-reservation-content"
    >
      <h1
        v-if="check.isLgAndUp"
        class="lookup-reservation-content__heading"
      >
        {{ BookingFormTitle }}
      </h1>
      <div
        class="lookup-reservation-content__sub-heading"
        v-text="BookingFormSubTitle"
      />
      <div class="form-wrapper">
        <form
          id="modify-reservation-lookup-form"
          class="form modify-reservation-lookup-form"
          @submit.prevent=""
        >
          <fieldset>
            <legend class="sr-only">
              {{ BookingFormTitle }}
            </legend>
            <div class="flex-grid-1-col gutter-lg">
              <div class="input lookup-number">
                <div class="input">
                  <input
                    id="lookupnumber"
                    v-model="LookUpNumber"
                    type="text"
                    name="lookupnumber"
                    maxlength="15"
                    value=""
                    class="req"
                    :class="{'valid':isValidLookUpNumber}"
                    data-val="true"
                    data-rule-maxlength="50"
                    :data-msg-maxlength="
                      getValidationForField('maxChars', '50')
                    "
                    :data-val-required="
                      getValidationForField('required', 'confirmationOrItinerary')
                    "
                    :data-val-no-special-chars="
                      tc('validations.noSpecialChars')
                    "
                    data-field-type="SingleLineText"
                  >
                  <label
                    for="lookupnumber"
                    class="req floating"
                  >
                    {{ tc("formFields.confirmationOrItinerary") }}
                  </label>
                  <span
                    data-valmsg-for="lookupnumber"
                    data-valmsg-replace="true"
                    class="field-validation-valid"
                  />
                </div>
              </div>
              <div class="input email">
                <input
                  id="email"
                  ref="EmailRef"
                  v-model="EmailValue"
                  type="text"
                  name="email"
                  value=""
                  class="req"
                  :class="{'valid':isEmailValid}"
                  data-val="true"
                  data-val-external="email"
                  data-rule-minlength="6"
                  data-rule-maxlength="255"
                  :data-msg-minlength="getValidationForField('minChars', '6')"
                  :data-msg-maxlength="getValidationForField('maxChars', '255')"
                  :data-external-msg="getValidationForField('externalEmail')"
                  :data-val-required="getValidationForField('required', 'email')"
                  :data-val-regex="getValidationForField('email')"
                  data-val-regex-pattern="^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,17}$"
                >
                <label
                  for="email"
                  class="req floating"
                >
                  {{ tc("formFields.email") }}
                </label>
                <span
                  data-valmsg-for="email"
                  data-valmsg-replace="true"
                  class="field-validation-valid"
                />
              </div>
            </div>
          </fieldset>
          <template v-if="ReCaptchaEnabled">
            <grecaptcha
              ref="grecaptchaLogin"
              :sitekey="ReCaptchaSiteKey"
              :element-id="'g-recaptcha'"
              @grecaptcha-callback="grecaptchaCallback"
              @grecaptcha-ready="grecaptchaReadyCallback"
            />
            <input
              v-model="grecaptchaToken"
              type="hidden"
              name="grecaptchaToken"
            >
            <input
              type="hidden"
              name="reCaptchaEnabled"
              :value="ReCaptchaEnabled"
            >
          </template>
          <div class="form-submit">
            <button
              v-if="ReCaptchaEnabled"
              :class="{'loading': readReservationLoading}"
              class="button lookup-cta"
              :disabled="!disableSubmit || !grecaptchaReady"
              @click.prevent="grecaptchaExecute"
              @keydown.space.prevent="grecaptchaExecute"
              @keydown.enter.prevent="grecaptchaExecute"
            >
              <span>{{ BookingFormButtonLabel }}</span>
            </button>
            <button
              v-else
              :class="{'loading': readReservationLoading}"
              class="button lookup-cta"
              :disabled="!disableSubmit"
              @click.prevent="submit"
              @keydown.space.prevent="submit"
              @keydown.enter.prevent="submit"
            >
              <span>{{ BookingFormButtonLabel }}</span>
            </button>
            <div
              class="sr-only"
              role="status"
            >
              {{ readReservationLoading ? tc('accessibility.loadingButtonStatus') : '' }}
            </div>
          </div>
          <div
            class="error-msg"
            role="status"
            v-html="getReadReservationError"
          />
          <loading-dots />
        </form>
        <div
          class="lookup-reservation-footertext"
          v-html="BookingFormFooterText"
        />
      </div>
    </div>

    <!-- Desktop Layout Image -->
    <div
      v-if="check.isLgAndUp"
      class="lookup-reservation-image"
    >
      <picture
        v-lazyload="{
          src: `${BookingFormImage}`,
          set: [
            { width: '1024',height: 576, breakpoint: 'xs' },
            { width: '1280', height: 720, breakpoint: 'md' },
            { width: '1600', height: 900, breakpoint: 'lg' },
          ],
          fit: 'crop',
          align: 'center',
        }"
        class="image-wrapper background"
      >
        <img
          class="image"
          src="data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw=="
          :alt="modifyBookingPropData.BookingFormImageAlt"
        >
      </picture>
    </div>
  </section>
</template>

<script>
  import { mapGetters, mapState, mapActions } from 'vuex'
  import { debounceAsync } from '@utils/timing'
  import Grecaptcha from '@components/02.account/grecaptcha/grecaptcha.vue'

  export default {
    name: 'LookupReservation',
    components: {
      Grecaptcha
    },
    data: () => ({
      LookUpNumber: '',
      EmailValue: '',
      showErrorMessage: false,
      grecaptchaToken: '',
      grecaptchaReady: false,
      showLoading: false
    }),
    computed: {
      ...mapState('modifyReservation', [
        'readReservationError',
        'readReservationLoading',
        'modifyBookingPropData'
      ]),
      ...mapState('responsive', ['check']),
      ...mapGetters('i18n', ['tc']),
      ...mapGetters('modifyReservation', ['getBookingTrackingModifyReservation']),
      isValidLookUpNumber() {
        return this.LookUpNumber.trim() !== ''
      },
      isEmailValid() {
        const regex = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,17}$/
        return regex.test(this.EmailValue)
      },
      disableSubmit() {
        return this.isValidLookUpNumber && this.isEmailValid
      },
      lookUpData() {
        return { LookUpNumber: this.LookUpNumber, Email: this.EmailValue }
      },
      BookingFormTitle() {
        return this.modifyBookingPropData?.BookingFormTitle || ''
      },
      BookingFormSubTitle() {
        return this.modifyBookingPropData?.BookingFormSubTitle || ''
      },
      BookingFormButtonLabel() {
        return this.modifyBookingPropData?.BookingFormButtonLabel || ''
      },
      BookingFormFooterText() {
        return this.modifyBookingPropData?.BookingFormFooterText || ''
      },
      BookingFormImage() {
        return this.modifyBookingPropData?.BookingFormImage || ''
      },
      BookingFormImageAlt() {
        return this.modifyBookingPropData?.BookingFormImageAlt || ''
      },
      ReCaptchaEnabled() {
        return this.modifyBookingPropData?.ReCaptchaEnabled || false
      },
      ReCaptchaSiteKey() {
        return this.modifyBookingPropData?.ReCaptchaSiteKey || ''
      },
      getReadReservationError() {
        return this.showErrorMessage && this.readReservationError ? this.readReservationError : ''
      }
    },
    mounted() {
      window.addEventListener('redirectLoading', this.redirectLoading)
      this.showErrorMessage = false
      this.$nextTick(() => {
        this.$track(this.getBookingTrackingModifyReservation({
          name: 'home >> modify >> find-reservation',
          siteSection: 'find'
        }, {}))
      })
    },
    created() {
      this.submit = debounceAsync(this.submit, 300)
    },
    destroyed() {
      window.removeEventListener('redirectLoading', this.redirectLoading)
    },
    methods: {
      ...mapActions('modifyReservation', ['readReservation']),
      getValidationForField(validation, field = '') {
        return this.tc(`validations.${validation}`).replace(
          '{0}',
          this.tc(`formFields.${field}`)
        )
      },
      async submit(obj) {
        const payload = {
          LookUpNumber: this.LookUpNumber,
          Email: this.EmailValue,
        }
        if (obj.repcaptchaToken) {
          payload.GrecaptchaToken = obj.repcaptchaToken
        }

        const data = await this.readReservation({ lookUpDataObject: payload })
        if (data.reservations) {
          this.$router.push({ name: 'modify-reservation-detail' })
          sessionStorage.setItem('storedReservationMyStaysEntry', false)
        } else {
          this.showErrorMessage = true
        }
      },
      grecaptchaCallback(token) {
        this.grecaptchaToken = token
        this.$nextTick(() => {
          this.submit({ repcaptchaToken: token })
        })
      },
      grecaptchaReadyCallback() {
        this.grecaptchaReady = true
      },
      grecaptchaExecute() {
        this.$root.$emit('grecaptcha-execute')
      },
      redirectLoading() {
        this.showLoading = true
      }
    },
  }
</script>
